var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChallengeTierBronzeSlim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3853 20H5.13527C4.78371 20 4.51027 20.3125 4.51027 20.625V21.875C4.51027 22.2266 4.78371 22.5 5.13527 22.5H21.3853C21.6978 22.5 22.0103 22.2266 22.0103 21.875V20.625C22.0103 20.3125 21.6978 20 21.3853 20ZM23.8853 7.5C22.8306 7.5 22.0103 8.35938 22.0103 9.375C22.0103 9.6875 22.0493 9.92188 22.1665 10.1562L19.354 11.875C18.729 12.2266 17.9478 12.0312 17.5962 11.4062L14.4321 5.82031C14.8618 5.50781 15.1353 4.96094 15.1353 4.375C15.1353 3.35938 14.2759 2.5 13.2603 2.5C12.2056 2.5 11.3853 3.35938 11.3853 4.375C11.3853 4.96094 11.6587 5.50781 12.0493 5.82031L8.88527 11.4062C8.53371 12.0312 7.75246 12.2266 7.16652 11.875L4.31496 10.1562C4.43215 9.92188 4.51027 9.6875 4.51027 9.375C4.51027 8.35938 3.6509 7.5 2.63527 7.5C1.58059 7.5 0.760274 8.35938 0.760274 9.375C0.760274 10.4297 1.58059 11.25 2.63527 11.25C2.7134 11.25 2.83059 11.25 2.90871 11.25L5.76027 18.75H20.7603L23.5728 11.25C23.6509 11.25 23.7681 11.25 23.8853 11.25C24.9009 11.25 25.7603 10.4297 25.7603 9.375C25.7603 8.35938 24.9009 7.5 23.8853 7.5Z",
    fill: "#C9995F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChallengeTierBronzeSlim);
export default __webpack_public_path__ + "static/media/challenge-tier-bronze-slim.0d85ecfb6829000f7dd15f9ebda24f47.svg";
export { ForwardRef as ReactComponent };